/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './logout.component.css.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../../app/auth/logout/logout.component';
import * as i3 from '@angular/router';
const styles_LogoutComponent:any[] = [i0.styles];
export const RenderType_LogoutComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_LogoutComponent,data:{}});
export function View_LogoutComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'p',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i1.ɵted((null as any),['\n  logout works!\n'])),(_l()(),i1.ɵted((null as any),
      ['\n']))],(null as any),(null as any));
}
export function View_LogoutComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'ltg-logout',([] as any[]),
      (null as any),(null as any),(null as any),View_LogoutComponent_0,RenderType_LogoutComponent)),
      i1.ɵdid(114688,(null as any),0,i2.LogoutComponent,[i3.Router],(null as any),
          (null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const LogoutComponentNgFactory:i1.ComponentFactory<i2.LogoutComponent> = i1.ɵccf('ltg-logout',
    i2.LogoutComponent,View_LogoutComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci93d3cvbGFudGFnby1hcHAvbGFudGFnby1hcHAtZGVtby9zcmMvYXBwL2F1dGgvbG9nb3V0L2xvZ291dC5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vdmFyL3d3dy9sYW50YWdvLWFwcC9sYW50YWdvLWFwcC1kZW1vL3NyYy9hcHAvYXV0aC9sb2dvdXQvbG9nb3V0LmNvbXBvbmVudC50cyIsIm5nOi8vL3Zhci93d3cvbGFudGFnby1hcHAvbGFudGFnby1hcHAtZGVtby9zcmMvYXBwL2F1dGgvbG9nb3V0L2xvZ291dC5jb21wb25lbnQuaHRtbCIsIm5nOi8vL3Zhci93d3cvbGFudGFnby1hcHAvbGFudGFnby1hcHAtZGVtby9zcmMvYXBwL2F1dGgvbG9nb3V0L2xvZ291dC5jb21wb25lbnQudHMuTG9nb3V0Q29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPHA+XG4gIGxvZ291dCB3b3JrcyFcbjwvcD5cbiIsIjxsdGctbG9nb3V0PjwvbHRnLWxvZ291dD4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7O29CQ0FBO01BQUEsd0VBQUc7YUFBQSx5Q0FFQztNQUFBOzs7b0JDRko7TUFBQTthQUFBO1VBQUE7SUFBQTs7OzsifQ==



// WEBPACK FOOTER //
// /var/www/lantago-app/lantago-app-demo/src/$$_gendir/app/auth/logout/logout.component.ngfactory.ts